import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.2443 3.02438L13.0021 7.99995L9.00712 9.00495L8.00212 10.9999L3.74932 7.81174M14.2443 3.02438C13.5254 2.84514 12.7733 2.75 11.999 2.75C8.39789 2.75 5.27739 4.80785 3.74932 7.81174M14.2443 3.02438C18.2679 4.02764 21.249 7.66569 21.249 12C21.249 17.1086 17.1077 21.25 11.999 21.25C6.89039 21.25 2.74902 17.1086 2.74902 12C2.74902 10.4925 3.10964 9.06923 3.74932 7.81174M15.002 17L16.002 15L13.054 13.019L11.111 12.895L10.002 14L12.002 17H15.002Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgGlobe;
